import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { Tabs } from 'antd';
import uniqBy from 'lodash/uniqBy';
import cn from 'classnames';
import trim from 'lodash/trim';
import { List, Navigate } from 'components/Files';
import { deleteDocument, onFileComplete, onFileProgress, onFileError } from 'redux_store/modules/tenderCard';
import { toggleTenderDocumentView } from 'redux_store/modules/view';
import styles from './styles.scss';
import { ListControl } from '../../../Files/listControl';
import { Upload } from '../../../Files/control/upload';

const { TabPane } = Tabs;

@reduxForm({
  form: 'cardDocumentsFilter',
  destroyOnUnmount: false,
})
@connect(
  ({ viewSettings, form: { cardDocumentsFilter }, tenderCard: { documentsLoading } }) => ({
    view: viewSettings.tenderDocumentView ? viewSettings.tenderDocumentView : 'grid',
    filterValue: (cardDocumentsFilter && cardDocumentsFilter.values && cardDocumentsFilter.values.name) || '',
    filterTag: (cardDocumentsFilter && cardDocumentsFilter.values && cardDocumentsFilter.values.tag) || '',
    isDocumentsLoading: documentsLoading,
  }),
  {
    deleteDocument,
    onFileComplete,
    onFileProgress,
    onFileError,
    toggleTabularView: toggleTenderDocumentView,
  },
)
export default class TenderDocuments extends React.PureComponent {
  static propTypes = {
    tenderId: PropTypes.number.isRequired,
    // eslint-disable-next-line react/forbid-prop-types
    docs: PropTypes.shape({ inner: PropTypes.arrayOf(PropTypes.object), pro: PropTypes.arrayOf(PropTypes.object) }),
    isEditAccess: PropTypes.bool,
    isDownloadAllInner: PropTypes.bool,
    isDownloadAllPro: PropTypes.bool,
    isDocumentsLoading: PropTypes.bool.isRequired,
    deleteDocument: PropTypes.func.isRequired,
    toggleTabularView: PropTypes.func.isRequired,
    onFileProgress: PropTypes.func.isRequired,
    onFileComplete: PropTypes.func.isRequired,
    onFileError: PropTypes.func.isRequired,
    view: PropTypes.string.isRequired,
    filterTag: PropTypes.string.isRequired,
    filterValue: PropTypes.string.isRequired,
  };

  static defaultProps = {
    docs: { inner: [], pro: [] },
    isEditAccess: true,
    isDownloadAllInner: true,
    isDownloadAllPro: true,
  };

  constructor(props) {
    super(props);
    this.state = {
      proLength: props.docs && props.docs.pro && props.docs.pro.length,
      innerLength: props.docs && props.docs.inner && props.docs.inner.length,
    };
  }

  getFilteredDoc = d => {
    if (!this.props.filterTag) return d;
    if (this.props.filterTag === 'Без пользователя') {
      return d.filter(e => e.tag === '');
    }
    return d.filter(e => e.tag === this.props.filterTag);
  };

  getListFilterOptions = (docs, fromPro) => {
    const options = uniqBy(
      docs.map(d => ({
        tag: trim(d.tag),
        id: d.id,
      })),
      'tag',
    ).filter(d => d.tag);
    if (!fromPro) {
      options.push({ id: -1, tag: 'Без пользователя' });
    }

    return options;
  };

  handleProDocsLength = num => {
    this.setState({ proLength: num });
  };

  handleInnerDocsLength = num => {
    this.setState({ innerLength: num });
  };

  render() {
    const {
      docs,
      isEditAccess,
      isDownloadAllInner,
      isDownloadAllPro,
      deleteDocument: onDeleteDocument,
      tenderId,
      toggleTabularView,
      view,
    } = this.props;
    const docsPro = (docs && docs.pro) || [];
    const docsInner = (docs && docs.inner) || [];
    const filteredProDocs = this.getFilteredDoc((docs && docs.pro) || []);
    const filteredInnerDocs = this.getFilteredDoc((docs && docs.inner) || []);
    return (
      <div className={styles.documentsWrapper}>
        <Navigate view={view} toggleTabularView={toggleTabularView} />
        <div className={styles.tabsWrapper}>
          <Tabs defaultActiveKey="1">
            <TabPane tab={`Конкурсная документация (${this.state.proLength})`} key="1">
              <div className={styles.tabsContentWrapper}>
                <ListControl
                  id={tenderId}
                  docs={filteredProDocs}
                  options={this.getListFilterOptions(docsPro, true)}
                  isUploadAccess={false}
                  filterPlaceholder="Тип документа"
                  uploadLink="/tender/doc/upload"
                  allDocsDownloadLink={`/pro/allpro/${tenderId}`}
                  isAccessDownloadAll={isDownloadAllPro}
                  onFileProgress={this.props.onFileProgress}
                  onFileComplete={this.props.onFileComplete}
                  onFileError={this.props.onFileError}
                />
                <List
                  isLoading={this.props.isDocumentsLoading}
                  isExternalFiles
                  docs={filteredProDocs}
                  isEditAccess={false}
                  onDeleteDocument={onDeleteDocument}
                  handleDocsLength={this.handleProDocsLength}
                  view={view}
                  filterValue={this.props.filterValue}
                />
              </div>
            </TabPane>
            <TabPane tab={`Внутренняя документация (${this.state.innerLength})`} key="2">
              <div className={styles.tabsContentWrapper}>
                <ListControl
                  uploadBtn={
                    <Upload
                      id={tenderId}
                      uploadLink="/tender/doc/upload"
                      onFileProgress={this.props.onFileProgress}
                      onFileComplete={this.props.onFileComplete}
                      onFileError={this.props.onFileError}
                    />
                  }
                  docs={filteredInnerDocs}
                  options={this.getListFilterOptions(docsInner)}
                  isUploadAccess={isEditAccess}
                  filterPlaceholder="Пользователь"
                  allDocsDownloadLink={`/tender/doc/all/${tenderId}`}
                  isAccessDownloadAll={isDownloadAllInner}
                />
                <List
                  isLoading={this.props.isDocumentsLoading}
                  docs={filteredInnerDocs}
                  handleDocsLength={this.handleInnerDocsLength}
                  isEditAccess={isEditAccess}
                  onDeleteDocument={onDeleteDocument}
                  view={view}
                  filterValue={this.props.filterValue}
                />
                {isEditAccess && (
                  <div
                    className={cn(styles.upload_wrapper, {
                      [styles.upload_wrapper_hidden]: filteredInnerDocs.length !== 0,
                    })}
                  >
                    <Upload
                      id={tenderId}
                      uploadLink="/tender/doc/upload"
                      onFileProgress={this.props.onFileProgress}
                      onFileComplete={this.props.onFileComplete}
                      onFileError={this.props.onFileError}
                    />
                  </div>
                )}
              </div>
            </TabPane>
          </Tabs>
        </div>
      </div>
    );
  }
}
